var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.consentGiven && _vm.hasTranslation)?_c('div',{staticClass:"cookie-consent"},[_c('p',[_vm._v(_vm._s(_vm.translation.message)+"\n    "),_c('router-link',{attrs:{"to":"/privacy-policy"}},[_vm._v(_vm._s(_vm.translation.privacyPolicy))]),_vm._v(".\n  ")],1),_vm._v(" "),_c('button',{on:{"click":_vm.acceptCookies}},[_vm._v(_vm._s(_vm.translation.acceptButton))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fbe0414","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/CookieConsent.vue
// module id = 858
// module chunks = 0